import React from 'react';
import { MainLayout } from 'COMPONENTS/Layout';
import IMG from 'ASSETS/zombie.svg';

import './GenericErrorPage.less';

const GenericErrorPage = () => (
  <MainLayout>
    <div className="error-page">
      <div className="left-content">
        <IMG width="200" />
      </div>
      <div className="right-content">
        <span className="error-type">Whoops!</span>
        <span className="error-title">Something unexpected happened</span>
        <span className="error-desc">Please reload and try again</span>
      </div>
    </div>
  </MainLayout>
);

export default GenericErrorPage;



// WEBPACK FOOTER //
// ./src/pages/ErrorPages/GenericError/GenericErrorPage.js